<template>

  <div v-if="hasCompanies">
    <table class="table table-borderless table-border table-align table-h51">
      <thead>
      <tr>
        <th>Razão Social</th>
        <th>CNPJ</th>
        <th>UF</th>
        <th>E-mail</th>
        <th>Telefone</th>
        <th></th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="company in companies" :key="company.id">
        <td>{{ company.name | uppercase }}</td>
        <td>{{ company.cnpj | cnpj }}</td>
        <td>{{ company.uf }}</td>
        <td>{{ company.email }}</td>
        <td>{{ company.phone }}</td>
        <td class="text-right">
          <button @click="$emit('showCompany', company)" class="btn-icon btn-outline">
            <edit-icon size="1.5x"/>
          </button>
          <button v-if="$withPolicy('application', 'companies/delete')"
                  @click="$emit('sendDeleteCompany', company)"
                  class="btn-icon btn-outline-red ml-2 mr-3">
            <trash-2-icon size="1.5x"/>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
  <div v-else>
    <p class="mt-4">
      Não foi encontrado nenhum fornecedor cadastrado
    </p>
  </div>
</template>

<script>
  import { Trash2Icon, EditIcon } from 'vue-feather-icons'

  export default {
    components: { EditIcon, Trash2Icon },
    methods: {
      checkDate(string) {
        if (string) {
          const date = new Date(string)
          return date > new Date()
        }
      },
    },
    name: 'Index',
    props: {
      companies: { required: true, type: Array}
    },
    computed: {
      hasCompanies() {
        return this.companies.length > 0
      }
    },
  }
</script>

<style scoped>

</style>
